import {createStore} from "effector";

export const $showSuccess = createStore(false)

